module.exports = __webpack_public_path__ + "bbef24e066e4be6b24f6fc2891292aca.arrow-mobile.svg";